import React from 'react';
import './Button.css';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'medium',
  className = '',
  loading = false,
  disabled = false
}) => {
  return (
    <button
      className={`button ${variant} ${size} ${className} ${loading ? 'loading' : ''}`}
      onClick={onClick}
      disabled={disabled || loading}
    >
      <span className="button-glow" />
      {loading ? (
        <span className="button-loading">
          <span className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button; 